<ng-container [formGroup]="form">
  <nz-form-item *ngIf="behaviorGoal && behaviorGoal.statusId !== 2">
    <nz-form-label nzFor="district-instructions"
      >District Instructions</nz-form-label
    >
    <nz-form-control>
      <textarea
        disabled
        id="district-instructions"
        name="district-instructions"
        aria-label="District Instructions"
        rows="4"
        nz-input
        [value]="behaviorGoal.templateInstructions"
        placeholder="District Instructions"></textarea>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzFor="goal" [nzRequired]="isRequired">Goal</nz-form-label>
    <nz-form-control>
      <textarea
        id="goal"
        name="goal"
        aria-label="Goal"
        rows="4"
        formControlName="goals"
        nz-input
        [placeholder]="
          getBehaviorGoalLabel(form.get('behaviorCategoryId')?.value)
        "
        (input)="onControlInputChange($event, form.get('goals'))"></textarea>
      <div class="mt-3 remaining-text">
        {{ form.value?.goals?.length }} of 4000 characters used
      </div>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="form.get('goals')?.hasError('required')">
        Please enter goal.
      </div>
    </nz-form-control>
  </nz-form-item>
  <button
    nz-button
    nzType="text"
    class="primary-text-btn"
    (click)="openExampleOfGoals.emit()">
    Full List of Ex. Behavior Goals
  </button>
</ng-container>
